import * as i0 from '@angular/core';
import * as i1 from './collapse.module';
import * as i2 from './collapse.directive';
export const CollapseModuleNgFactory:i0.NgModuleFactory<i1.CollapseModule> = (null as any);
var _decl0_0:i2.CollapseDirective = (<any>(null as any));
var _decl0_1:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_2:i0.ElementRef<any> = (<any>(null as any));
